import { useTranslation } from 'react-i18next';

import { useTableFilterQuery } from '../../hooks/filter';
import { useStore } from '../../store';
import { FilterConfigDto } from '../../store/states/filterTypes';

import { FiltersComponent } from './FiltersComponent';

export type TableFilterProps = {
  config?: { filters?: FilterConfigDto[] };
  pageFilterInstanceId: string;
  tableFilterInstanceId: string;
  widgetId: string;
};

const hasFilters = (
  config: TableFilterProps['config']
): config is Exclude<TableFilterProps['config'], undefined> =>
  Boolean(config?.filters?.length);

export const TableFilters = ({
  config,
  pageFilterInstanceId,
  tableFilterInstanceId,
  widgetId,
}: TableFilterProps) => {
  const { t } = useTranslation();

  const resetFilterSelections = useStore(
    (state) => state.resetFilterSelections
  );

  const query = useTableFilterQuery(
    widgetId,
    tableFilterInstanceId,
    pageFilterInstanceId,
    config?.filters
  );

  if (!hasFilters(config)) {
    return undefined;
  }

  return (
    <FiltersComponent
      config={config}
      entityId={tableFilterInstanceId}
      error={query.error}
      filterTestId="table-filters"
      isFetching={query.isFetching}
      resetFilterSelection={resetFilterSelections}
      translate={t}
      validatedData={query.validatedData}
    />
  );
};
